import React from "react";
import News_6 from "../../../assets/images/gallery/2025/jan/sci/Sci (2).jpeg";
import News_7 from "../../../assets/images/gallery/2025/jan/sci/Sci (4).jpeg";
import News_8 from "../../../assets/images/gallery/2025/jan/pongal festival/Img  (3).jpeg";
import  News_3 from "../../../assets/images/gallery/2025/march/womensday/img  (1).JPG";
import  News_4 from "../../../assets/images/gallery/2025/march/rally/1.jpeg";
import  News_5 from "../../../assets/images/gallery/2025/march/rally/Img  (1).jpeg";
import  News_2 from "../../../assets/images/gallery/2025/march/upcoimg event/Img (1).jpeg";
import  News_1 from "../../../assets/images/gallery/2025/march/upcoimg event/IMAGe (1).jpeg";
import News_10 from "../../../assets/images/gallery/2025/July/Freshersday/img  (5).jpeg";
import News_11 from "../../../assets/images/gallery/2025/July/Food festival/Img (3).jpeg";
import News_12 from "../../../assets/images/gallery/2025/Aug/Tamil ilakiya vila/IMG (1).jpeg";
import News_13 from "../../../assets/images/gallery/2025/Aug/Nss/Img (1).jpeg";
import News_14 from "../../../assets/images/gallery/2025/Aug/guest lectur/Img  (1).jpeg";
import News_15 from "../../../assets/images/gallery/2025/Aug/Guest lectur -ai/Img  (1).jpeg";
import News_16 from "../../../assets/images/gallery/2025/Aug/micro biolozoy/Img  (2).jpeg";
import News_17 from "../../../assets/images/gallery/2025/sep/onam celebration/IMG (2).jpeg";
import News_18 from "../../../assets/images/gallery/2025/sep/Naan Mudhalvan/Img (1).jpeg";

import { Link } from "react-router-dom";


const CardGrid = () => {
  const cardsData = [ 
     {
      url: News_18,
      title: " Students Qualify for Naan Mudhalvan Employability Programme",
      text: "",
      updatedTime: " ",
    }, 
     {
      url: News_17,
      title: " Onam Celebrations-2k25",
      text: "",
      updatedTime: " ",
    },  
     {
      url: News_16,
      title: "Guest Lecture Program-Hidden World of Microbes/Microbiomes ",
      text: "",
      updatedTime: " ",
    },  
     {
      url: News_15,
      title: " Guest Lecture Program-Artificial Intelligence",
      text: "",
      updatedTime: " ",
    },   
    {
      url: News_14,
      title: " Guest Lecture Program-Applications of Nanotechnology",
      text: "",
      updatedTime: " ",
    }, 
    {
      url: News_13,
      title: "NSS Camp-2K25",
      text: "",
      updatedTime: " ",
    }, 
      {
      url: News_12,
      title: "முத்தமிழ் இலக்கிய மன்ற விழா ",
      text: "",
      updatedTime: " ",
    },                                                                              
      {
      url: News_11,
      title: "Food Festival 2k25 ",
      text: "",
      updatedTime: " ",
    },
      {
      url: News_10,
      title: "Fresh Fiesta 2K25, Freshers' Day celebration",
      text: "",
      updatedTime: " ",
    },
    {
      url: News_1,
      title: "5'th Graduations Day ",
      text: "",
      updatedTime: " ",
    },
    {
      url: News_2,
      title: "12'th Annuval Day",
      text: "",
      updatedTime: "",
    },


    {
      url: News_3,
      title: "Womes day Celebration",
      text: "",
      updatedTime: " 15 March 2025",
    },
    {
      url: News_4,
      title: "Nilavembu Kashayam Camp",
      text: "",
      updatedTime: "4 February 2025",
    },
    {
      url: News_5,
      title: "Science Expo 2k25",
      text: "",
      updatedTime: "4 February 2025",
    },




    {
      url: News_6,
      title: "Science Expo 2k25",
      text: "",
      updatedTime: "4 February 2025",
    },
    {
      url: News_7,
      title: " Science Expo 2k25",
      text: "",
      updatedTime: "4 February 2025",
    },
    {
      url: News_8,
      title: "Pongal Celebrations",
      text: "",
      updatedTime: "11 January  2025",
    },
   
  ];

  return (
    <div className="row row-cols-1 row-cols-md-3 g-4">
      {cardsData.map((card, index) => (
        <Card key={index} {...card} />
      ))}
    </div>
  );
};

const Card = ({  url, title, text, updatedTime }) => {
    return (
      <div className="col">
        <div className="card h-100">
          <img src={ url} className="card-img-top" alt="Card" />
          <div className="card-body">
            <h5 className="card-title">{title}</h5>
            <p className="card-text">{text}</p>
            <Link to="/gallery/2025" class="btn btn-primary">More Details </Link>
          </div>
          {/* <div className="card-footer">
            <small className="text-muted">Last updated {updatedTime} ago</small>
          </div> */}
        </div>
      </div>
    );
  };
export default CardGrid;
